const fakeData = {
  // danh sach tram sac
  chargeStationList: [
    {
      stationId: 1,
      name: 'Trạm sạc Duy Tân',
      partnerCode: null,
      latitude: null,
      longitude: null,
      createdAt: '2024-08-15T09:00:18.000Z',
      updatedAt: '2024-08-15T09:00:18.000Z',
      operatorId: 1,
      chargePoints: [
        {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-19T04:08:27.000Z',
        },
      ],
    },
  ],

  // chi tiet 1 tram sac
  chargeStationInfo: {
    chargePoints: [
      {
        pointId: 1,
        stationId: 1,
        power: null,
        vendor: 'Bender GmbH Co. KG',
        type: null,
        serialNumber: '2108552500',
        model: 'CC613_ELM4PR',
        operatorId: 1,
        firmwareVersion: '5.32.2-18998',
        connected: 1,
        iccid: 'E0:AE:B2:01:F5:71',
        imsi: 'eth0',
        phoneNumber: null,
        numberConnectors: 1,
        voltage: null,
        maxAmpere: null,
        protocol: 'OCPP1.6',
        ocppId: 'ITC-CP-001',
        ipAddress: null,
        status: 'CHARGING',
        createdAt: '2024-08-12T19:21:58.000Z',
        updatedAt: '2024-08-19T14:28:03.000Z',
        chargeConnectors: [
          {
            connectorId: 2,
            pointId: 1,
            connectorNumber: 1,
            currentTotalPower: 123,
            temperature: 29,
            type: 'CCS2',
            status: 'CHARGING',
            createdAt: '2024-08-14T22:11:26.000Z',
            updatedAt: '2024-08-20T07:51:54.000Z',
          },
        ],
      },
    ],
  },

  // danh sach phien sac
  chargeTransactionList: [
    {
      transactionId: 2,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'CHARGING',
      startingMeter: 0,
      power: null,
      energy: 0,
      current: 0,
      vehicleId: null,
      userId: null,
      percentComplete: null,
      idTag: null,
      plate: null,
      startTime: '2024-08-15T05:59:31.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-15T05:59:31.000Z',
      updatedAt: '2024-08-15T05:59:31.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: null,
      chargeRFID: null,
    },
    {
      transactionId: 3,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'CHARGING',
      startingMeter: 0,
      power: null,
      energy: 0,
      current: 0,
      vehicleId: null,
      userId: null,
      percentComplete: null,
      idTag: null,
      plate: null,
      startTime: '2024-08-15T06:04:11.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-15T06:04:11.000Z',
      updatedAt: '2024-08-15T06:04:11.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: null,
      chargeRFID: null,
    },
    {
      transactionId: 4,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'CHARGING',
      startingMeter: 0,
      power: null,
      energy: 0,
      current: 0,
      vehicleId: null,
      userId: null,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-15T10:49:53.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-15T10:49:53.000Z',
      updatedAt: '2024-08-15T10:49:53.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: null,
      chargeRFID: null,
    },
    {
      transactionId: 5,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'CHARGING',
      startingMeter: 0,
      power: null,
      energy: 0,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-15T10:54:22.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-15T10:54:22.000Z',
      updatedAt: '2024-08-15T10:54:22.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 6,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'CHARGING',
      startingMeter: 0,
      power: null,
      energy: 0,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-15T11:02:53.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-15T11:02:53.000Z',
      updatedAt: '2024-08-15T11:02:53.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 7,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'CHARGING',
      startingMeter: 0,
      power: null,
      energy: 0,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-15T11:12:44.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-15T11:12:44.000Z',
      updatedAt: '2024-08-15T11:12:44.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 8,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'CHARGING',
      startingMeter: 0,
      power: null,
      energy: 0,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-15T11:14:26.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-15T11:14:26.000Z',
      updatedAt: '2024-08-15T11:14:26.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 9,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 0,
      power: null,
      energy: 6,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-15T11:19:46.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-15T11:19:46.000Z',
      updatedAt: '2024-08-15T11:38:17.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 10,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 0,
      power: null,
      energy: 63,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-16T04:14:00.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-16T04:14:00.000Z',
      updatedAt: '2024-08-16T04:44:49.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 11,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 0,
      power: null,
      energy: 2,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-16T04:45:10.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-16T04:45:10.000Z',
      updatedAt: '2024-08-16T04:45:49.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 12,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 0,
      power: 123,
      energy: 5,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-16T05:02:05.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-16T05:02:05.000Z',
      updatedAt: '2024-08-16T05:04:39.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 13,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 0,
      power: 123,
      energy: 17,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-16T05:08:21.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-16T05:08:21.000Z',
      updatedAt: '2024-08-16T05:16:54.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 14,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 0,
      power: 124,
      energy: 5,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-16T05:19:07.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-16T05:19:07.000Z',
      updatedAt: '2024-08-16T05:21:26.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 15,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 0,
      power: null,
      energy: 0,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-16T05:21:42.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-16T05:21:42.000Z',
      updatedAt: '2024-08-16T05:22:11.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 16,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 5042,
      power: 123,
      energy: 16,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-16T05:25:39.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-16T05:25:39.000Z',
      updatedAt: '2024-08-16T05:33:27.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 17,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 5058,
      power: 123,
      energy: 7,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-16T05:35:34.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-16T05:35:34.000Z',
      updatedAt: '2024-08-16T05:38:43.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 18,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 5065,
      power: 123,
      energy: 4,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-16T07:19:42.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-16T07:19:42.000Z',
      updatedAt: '2024-08-16T07:21:56.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 19,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 5069,
      power: 124,
      energy: 3,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-16T08:11:56.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-16T08:11:56.000Z',
      updatedAt: '2024-08-16T08:14:28.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 20,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 5072,
      power: 123,
      energy: 2,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-16T08:17:24.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-16T08:17:24.000Z',
      updatedAt: '2024-08-16T08:19:51.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 21,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 5074,
      power: 123,
      energy: 6,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-16T08:20:41.000Z',
      endTime: '2024-08-16T08:23:54.000Z',
      holdDuration: 46,
      createdAt: '2024-08-16T08:20:41.000Z',
      updatedAt: '2024-08-16T08:24:44.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 22,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 5080,
      power: 124,
      energy: 12,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-16T08:34:04.000Z',
      endTime: '2024-08-16T08:40:00.000Z',
      holdDuration: 2,
      createdAt: '2024-08-16T08:34:04.000Z',
      updatedAt: '2024-08-16T08:40:02.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 23,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 5092,
      power: 123,
      energy: 2,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-16T08:47:01.000Z',
      endTime: '2024-08-16T08:47:39.000Z',
      holdDuration: 96237,
      createdAt: '2024-08-16T08:47:01.000Z',
      updatedAt: '2024-08-17T11:31:36.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 24,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 5094,
      power: null,
      energy: 1,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-16T08:47:57.000Z',
      endTime: '2024-08-16T08:48:26.000Z',
      holdDuration: 96395,
      createdAt: '2024-08-16T08:47:57.000Z',
      updatedAt: '2024-08-17T11:35:15.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 25,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 5095,
      power: 127,
      energy: 9,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-17T11:18:57.000Z',
      endTime: '2024-08-17T11:23:09.000Z',
      holdDuration: 1172,
      createdAt: '2024-08-17T11:18:57.000Z',
      updatedAt: '2024-08-17T11:42:43.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 26,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 5104,
      power: 126,
      energy: 10,
      current: 0,
      vehicleId: null,
      userId: 2,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-17T11:23:33.000Z',
      endTime: '2024-08-17T11:28:28.000Z',
      holdDuration: 0,
      createdAt: '2024-08-17T11:23:33.000Z',
      updatedAt: '2024-08-17T11:28:28.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 2,
        areaId: 1,
        fullname: 'Administrator',
        email: 'admin@mdcsoftware.com.vn',
        role: 'ADMIN',
        expirationDate: '2024-08-20T02:39:29.000Z',
        createdAt: null,
        updatedAt: '2024-08-19T02:39:29.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 27,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 5114,
      power: 125,
      energy: 1,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-17T11:31:36.000Z',
      endTime: '2024-08-17T11:32:26.000Z',
      holdDuration: 0,
      createdAt: '2024-08-17T11:31:36.000Z',
      updatedAt: '2024-08-17T11:32:26.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 28,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 5115,
      power: 125,
      energy: 10,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-17T11:34:50.000Z',
      endTime: '2024-08-17T11:39:42.000Z',
      holdDuration: 0,
      createdAt: '2024-08-17T11:34:50.000Z',
      updatedAt: '2024-08-17T11:39:43.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 29,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 5125,
      power: 125,
      energy: 2,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-17T11:42:28.000Z',
      endTime: '2024-08-17T11:43:25.000Z',
      holdDuration: 172,
      createdAt: '2024-08-17T11:42:28.000Z',
      updatedAt: '2024-08-17T11:46:17.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 30,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 5127,
      power: 126,
      energy: 3,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-17T11:46:17.000Z',
      endTime: '2024-08-17T11:47:21.000Z',
      holdDuration: 279,
      createdAt: '2024-08-17T11:46:17.000Z',
      updatedAt: '2024-08-17T11:52:00.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 31,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 5130,
      power: 126,
      energy: 13,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-17T11:52:00.000Z',
      endTime: '2024-08-17T11:57:59.000Z',
      holdDuration: 10601,
      createdAt: '2024-08-17T11:52:00.000Z',
      updatedAt: '2024-08-17T14:54:40.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 32,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 5143,
      power: 125,
      energy: 4663,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-17T14:54:40.000Z',
      endTime: '2024-08-19T10:17:17.000Z',
      holdDuration: 13931,
      createdAt: '2024-08-17T14:54:40.000Z',
      updatedAt: '2024-08-19T14:09:28.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 33,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 9806,
      power: 124,
      energy: 57,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-19T14:09:28.000Z',
      endTime: '2024-08-19T14:37:03.000Z',
      holdDuration: 370,
      createdAt: '2024-08-19T14:09:28.000Z',
      updatedAt: '2024-08-19T14:43:13.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 34,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'FINISHED',
      startingMeter: 9863,
      power: 124,
      energy: 19,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-19T14:43:13.000Z',
      endTime: '2024-08-19T14:52:50.000Z',
      holdDuration: 53733,
      createdAt: '2024-08-19T14:43:13.000Z',
      updatedAt: '2024-08-20T05:48:23.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
    {
      transactionId: 35,
      connectorId: 2,
      vendorTransactionId: null,
      status: 'CHARGING',
      startingMeter: 9882,
      power: 124,
      energy: 480,
      current: 0,
      vehicleId: null,
      userId: 1,
      percentComplete: null,
      idTag: '03070A1F',
      plate: null,
      startTime: '2024-08-20T05:48:23.000Z',
      endTime: null,
      holdDuration: 0,
      createdAt: '2024-08-20T05:48:23.000Z',
      updatedAt: '2024-08-20T09:44:25.000Z',
      chargeConnector: {
        connectorId: 2,
        pointId: 1,
        connectorNumber: 1,
        currentTotalPower: 124,
        temperature: 29,
        type: 'CCS2',
        status: 'CHARGING',
        createdAt: '2024-08-14T22:11:26.000Z',
        updatedAt: '2024-08-20T09:44:25.000Z',
        chargePoint: {
          pointId: 1,
          stationId: 1,
          power: null,
          vendor: 'Bender GmbH Co. KG',
          type: null,
          serialNumber: '2108552500',
          model: 'CC613_ELM4PR',
          operatorId: 1,
          firmwareVersion: '5.32.2-18998',
          connected: 1,
          iccid: 'E0:AE:B2:01:F5:71',
          imsi: 'eth0',
          phoneNumber: null,
          numberConnectors: 1,
          voltage: null,
          maxAmpere: null,
          protocol: 'OCPP1.6',
          ocppId: 'ITC-CP-001',
          ipAddress: null,
          status: 'CHARGING',
          createdAt: '2024-08-12T19:21:58.000Z',
          updatedAt: '2024-08-20T09:34:12.000Z',
        },
      },
      user: {
        userId: 1,
        areaId: 1,
        fullname: 'Luong Anh Hoang',
        email: 'hoang@mdcsoftware.com.vn',
        role: 'DRIVER',
        expirationDate: '2024-08-18T02:43:34.000Z',
        createdAt: null,
        updatedAt: '2024-08-17T14:43:34.000Z',
      },
      chargeRFID: null,
    },
  ],
  chargeRFIDs: [
    {
      rfidId: 2,
      idTag: '621D2551',
      operatorId: 1,
      vehicleId: 2,
      status: 'NORMAL',
      createdAt: '2024-08-14T21:58:58.000Z',
      updatedAt: '2024-08-14T21:58:58.000Z',
      vehicle: {
        vehicleId: 2,
        vehicleType: 'CAR',
        plate: '30A-99999',
        userId: 3,
        vinNumber: '1234567890AAAA',
        createdAt: '2024-08-19T00:35:57.000Z',
        updatedAt: '2024-08-19T00:35:57.000Z',
        modelId: 0,
      },
    },
  ],

  fakeQrData: {
    bin: '970422',
    accountNumber: '0945666977',
    accountName: 'LUONG ANH HOANG',
    amount: 2000,
    description: 'CSFF6WU6NT6 CHARGE PAYMENT ID 100',
    orderCode: 100,
    currency: 'VND',
    paymentLinkId: '211a8ff74c5d47e1b93fc7d99872a4af',
    status: 'PENDING',
    checkoutUrl: 'https://pay.payos.vn/web/211a8ff74c5d47e1b93fc7d99872a4af',
    qrCode:
      '00020101021238540010A00000072701240006970422011009456669770208QRIBFTTA5303704540420005802VN62370833CSFF6WU6NT6 CHARGE PAYMENT ID 100630422C7',
  },
  fakePaymentData: {
    paymentId: 335,
    transactionId: 478,
    userId: 0,
    energy: 0,
    amount: 200000,
    status: 'COMPLETED',
    updatedAt: '2024-10-14T03:42:28.786Z',
    createdAt: '2024-10-14T03:42:28.786Z',
  },

  // super dashboard stations
  stationsList: [
    {
      "stationId": 7,
      "name": "Trạm sạc TP.HCM - Quận 1",
      "address": "Số 123 Nguyễn Huệ, Quận 1",
      "latitude": 10.762622,
      "longitude": 106.681612,
      "status": "NORMAL"
    },
    {
      "stationId": 8,
      "name": "Trạm sạc Đà Nẵng - Hải Châu",
      "address": "Số 50 Lê Duẩn, Quận Hải Châu",
      "latitude": 16.067287,
      "longitude": 108.218684,
      "status": "STOPPED"
    },
    {
      "stationId": 9,
      "name": "Trạm sạc Cần Thơ - Ninh Kiều",
      "address": "Số 200 Nguyễn Trãi, Quận Ninh Kiều",
      "latitude": 10.030399,
      "longitude": 105.779041,
      "status": "NORMAL"
    },
    {
      "stationId": 10,
      "name": "Trạm sạc Hà Nội - Long Biên",
      "address": "Số 50 Ngô Gia Tự, Quận Long Biên",
      "latitude": 21.047315,
      "longitude": 105.935865,
      "status": "NORMAL"
    },
    {
      "stationId": 11,
      "name": "Trạm sạc Quảng Ninh - Hạ Long",
      "address": "Số 20 Trần Phú, TP Hạ Long",
      "latitude": 20.953477,
      "longitude": 107.086563,
      "status": "MAINTAINING"
    },
    {
      "stationId": 12,
      "name": "Trạm sạc Bình Dương - Thủ Dầu Một",
      "address": "Số 100 Nguyễn Văn Cừ, TP Thủ Dầu Một",
      "latitude": 10.974173,
      "longitude": 106.643739,
      "status": "NORMAL"
    },
    {
      "stationId": 13,
      "name": "Trạm sạc Hải Phòng - Lê Chân",
      "address": "Số 15 Trần Hưng Đạo, Quận Lê Chân",
      "latitude": 20.852180,
      "longitude": 106.681257,
      "status": "NORMAL"
    }
  ]
};

export default fakeData;
